import { createRouter, createWebHistory } from 'vue-router';

// NOTE: do not import route-by-route for chunking! The app will be installed as
// a PWA and might cause unexpected behavior if certain routes have not been visited.
// Even though the app is not supposed to work offline, we might prevent some edge
// cases if we do not chunk.
import Home from '../views/HomePage.vue';
import LumarActivities from '@/views/LumarActivities.vue';
import ColorPalette from '@/views/ColorPalette.vue';
import Recommendations from '@/views/RecommendUs.vue';
import Contacts from '@/views/ProjectContacts.vue';
import AppInfo from '@/views/AppSettings.vue';

function routerFactory() {
  const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/lumar-activities',
        name: 'lumar-activities',
        component: LumarActivities
      },
      {
        path: '/color-palette',
        name: 'color-palette',
        component: ColorPalette
      },
      {
        path: '/recommendations',
        name: 'recommendations',
        component: Recommendations
      },
      {
        path: '/contacts',
        name: 'contacts',
        component: Contacts
      },
      {
        path: '/settings',
        name: 'version',
        component: AppInfo
      }
    ]
  });

  return router;
}

export default routerFactory;
